﻿import { validateStore, validateParcelTerminal } from "@/CartModule";
import { closeModal } from "@/sharedComponents/Modal";
import { closePanel } from "@/sharedComponents/Panel";
import {$, $$, get, hide, highlight, postDataText, show, toggle} from "@/Utils";
import {SelfServicePostType} from "@/enums";

export function initStoreAndPostPackageSelections() {
    const clickAlreadyCheckedCheckbox = (e: Event) => {
        const inputElement = e.target as HTMLInputElement
        if (inputElement.checked) {
            closeModal();
            closePanel();
        }
    };

    const chooseStore = get("choose-store")
    if (chooseStore) {
        chooseStore.addEventListener("click", clickAlreadyCheckedCheckbox)
        chooseStore.addEventListener("input", (e: Event) => {
            const inputElement = e.target as HTMLInputElement
            if (!inputElement) {
                return
            }
            if(inputElement.id == "StoreSearch"){
                displaySelection(inputElement, true);
            } else{
                // Change selection and close panel
                const actionButton = inputElement.closest(".action_button") as HTMLElement
                Array.from(actionButton.parentElement.children).forEach(x => x.classList.remove("action_button--active"))
                actionButton.classList.add("action_button--active")
                get("selected-store").innerHTML = actionButton.textContent.trim()
                closePanel();
                validateStore();
                // Deliver correct metainformation from back end to their containers
                const deliveryInfoContainer = get("delivery-info-container")
                deliveryInfoContainer.classList.remove("input-validation-error")
                const callback = (data: string) => {
                    deliveryInfoContainer.innerHTML = data
                    const shopDeliveryFrom = get("shop-delivery-from")
                    if (shopDeliveryFrom) {
                        const optGroupPriority = inputElement.getAttribute("data-opt-group-priority")
                        const optGroup = $(`[data-priority="${optGroupPriority}"]`)
                        if (optGroup) {
                            shopDeliveryFrom.innerHTML = optGroup.innerHTML
                        }
                    }
                }
                const id = parseInt(inputElement.value)
                postDataText(window.config.getStoreDeliveryInfoUrl, id, callback)
            }
        })
    }

    const choosePostPackage = get("choose-post-package");
    if (choosePostPackage) {
        choosePostPackage.addEventListener("click", clickAlreadyCheckedCheckbox)
        choosePostPackage.addEventListener("input", (e: Event) => {
            const inputElement = e.target as HTMLInputElement
            if (!inputElement) {
                return
            }
            if (inputElement.id === "ParcelLocationName") {
                displaySelection(inputElement, false);
            } else {
                // Change selection and close modal
                const actionButton = inputElement.closest(".action_button") as HTMLElement
                Array.from(actionButton.parentElement.children).forEach(x => x.classList.remove("action_button--active"))
                actionButton.classList.add("action_button--active")
                const selectedPostPackage = get("selected-post-package")
                selectedPostPackage.innerHTML = actionButton.textContent.trim()
                selectedPostPackage.removeAttribute("data-not-chosen")
                const shippingError = get("shipping-phone-error")
                if (shippingError) {
                    hide(shippingError)
                }
                const dpdPhoneWarning = get("shipping-phone-dpd-warning")
                if (dpdPhoneWarning) {
                    if(actionButton.getAttribute("data-type") === SelfServicePostType.DPD){
                        show(dpdPhoneWarning)
                    }
                    else{
                        hide(dpdPhoneWarning)
                    }
                }
                $("[data-container-for='PostPackage'] .cart-transport__price").textContent = `${actionButton.getAttribute("data-parcel-price")} ${window.config.currencySign}`;
                closeModal()
                validateParcelTerminal(false, false);
            }
        });

        $$(".type-filter-elem")?.forEach(e => e.addDataBoundEventListener("click", () => {
            const activeClass = "type-filter-elem--active";
            const inputElement = get("ParcelLocationName") as HTMLInputElement;

            const isActive = e.classList.contains(activeClass);
            if(isActive){
                e.classList.remove(activeClass);
            }else{
                $$(".type-filter-elem--active")?.forEach(ae => ae.classList.remove(activeClass));
                e.classList.add(activeClass);
            }
            displaySelection(inputElement, false);
        }))
    }
    
    function displaySelection(inputElement: HTMLInputElement, isStore: boolean){
        const elemId = isStore ? "choose-store-panel" : "choose-post-package"
        const searchTerm = inputElement.value;
        const activeType = $(".type-filter-elem--active")?.getAttribute("data-type");
        Array.from($$(`#${elemId} [data-typeahead-results] .action_button`)).forEach(x => {
            const highlighted = highlight(x.getAttribute("data-name"), searchTerm)
            x.querySelector(".content").innerHTML = highlighted
            toggle(x, (!searchTerm || highlighted.lastIndexOf("<mark>") >= 0) && (x.getAttribute("data-type") == activeType || activeType == null))
        });
    }
}
